import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "HangingProtocol"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M19.777 15.3901L12.7495 11.5576V10.3951C14.2602 10.005 15.2197 8.52208 14.9564 6.98419C14.6932 5.4463 13.295 4.36694 11.7406 4.50156C10.1862 4.63619 8.99442 5.93986 8.99948 7.50011H10.4995C10.545 6.96421 10.873 6.49332 11.3599 6.26482C11.8468 6.03632 12.4186 6.08492 12.8599 6.39232C13.3012 6.69972 13.545 7.21921 13.4995 7.75511C13.3463 8.50056 12.6775 9.02667 11.917 9.00011C11.5483 9.00011 11.2495 9.29896 11.2495 9.66761V11.5576L4.22198 15.3901C3.76253 15.6339 3.3981 16.0248 3.18698 16.5001C2.8896 17.155 2.94413 17.916 3.33185 18.5218C3.71958 19.1276 4.38773 19.4958 5.10698 19.5001H18.892C19.6112 19.4958 20.2794 19.1276 20.6671 18.5218C21.0548 17.916 21.1094 17.155 20.812 16.5001C20.6008 16.0248 20.2364 15.6339 19.777 15.3901ZM18.892 18.0001H5.10705C4.77153 18.0001 4.49955 17.7281 4.49955 17.3926C4.4988 17.1178 4.64844 16.8646 4.88955 16.7326L11.9995 12.8551L19.1095 16.7326C19.3507 16.8646 19.5003 17.1178 19.4995 17.3926C19.4995 17.7281 19.2276 18.0001 18.892 18.0001Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/HangingProtocol.vue"]]);
